<label
  class="fi-checkbox"
  [class.fi-checkbox--block]="block"
  [class.fi-checkbox--error]="!!error"
  [class.fi-checkbox--disabled]="disabled"
>
  <span class="fi-checkbox__control">
    <input
      #input
      type="checkbox"
      class="fi-checkbox__input"
      [checked]="checked"
      [disabled]="disabled"
      (change)="onInputChange($event)"
    >
    <span class="fi-checkbox__box"></span>
  </span>

  <span class="fi-checkbox__text">
    <span class="fi-checkbox__label">
      <ng-content></ng-content>
      <span *ngIf="required" class="fi-checkbox__required">&nbsp;*</span>
    </span>
    <span *ngIf="hint" class="fi-checkbox__hint">{{ hint }}</span>
    <span *ngIf="error" class="fi-checkbox__error-text">{{ error }}</span>
  </span>
</label>
